/**
 * Pre-compiled localized messages for SearchInput component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import searchInputMessages_en from "./intl/en";
import searchInputMessages_de from "./intl/de";
import searchInputMessages_es from "./intl/es";
import searchInputMessages_fr from "./intl/fr-FR";
import searchInputMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const searchInputMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(searchInputMessages_en),
  de: normalizeMessages(searchInputMessages_de),
  es: normalizeMessages(searchInputMessages_es),
  "fr-FR": normalizeMessages(searchInputMessages_fr),
  "pt-BR": normalizeMessages(searchInputMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for SearchInput component
 */
export type SearchInputMessageKey = "clearInput";
